<p>
  line-of-business-detail works!
</p>
